/* fb vitrin: SADECE tum urunleri goster (250 otesi). Karistirma YOK, gizleme YOK. Ilk 250 canlidaki gibi. */
(function(){
function boot(){
  var sec=document.querySelector(".fifty-product-showcase");
  var grid=sec&&sec.querySelector(".fps-wrapper");
  if(!sec||!grid)return;
  try{sec.querySelectorAll(".fps-pagination").forEach(function(p){p.remove();});}catch(e){}
  var loaded={};
  try{grid.querySelectorAll('.fps-card:not(.fps-clone) a[href*="/products/"]').forEach(function(a){var h=(a.getAttribute("href")||"").split("?")[0];if(h)loaded[h]=1;});}catch(e){}
  var PS=250,sid=sec.id.replace(/^section-/,""),page=1,busy=false,fin=false;
  function firstOos(){var c=grid.querySelectorAll(".fps-card:not(.fps-clone)");for(var i=0;i<c.length;i++){if(c[i].querySelector(".fps-oos"))return c[i];}return null;}
  function add(c,where){var n=document.importNode(c,true);n.classList.remove("fps-anim");n.classList.add("fps-in");if(where)grid.insertBefore(n,where);else grid.appendChild(n);}
  function next(){
    if(busy||fin)return;busy=true;page++;
    fetch(location.pathname+"?section_id="+encodeURIComponent(sid)+"&page="+page,{headers:{"X-Requested-With":"XMLHttpRequest"}})
    .then(function(r){return r.text();})
    .then(function(html){
      var doc=new DOMParser().parseFromString(html,"text/html");
      var src=doc.querySelector(".fps-wrapper");
      var cs=src?[].slice.call(src.querySelectorAll(".fps-card:not(.fps-clone)")):[];
      var nin=[],noo=[],added=0;
      cs.forEach(function(c){var a=c.querySelector('a[href*="/products/"]');var h=a?(a.getAttribute("href")||"").split("?")[0]:null;if(h&&loaded[h])return;if(h)loaded[h]=1;(c.querySelector(".fps-oos")?noo:nin).push(c);added++;});
      var b=firstOos();
      nin.forEach(function(c){add(c,b);});
      noo.forEach(function(c){add(c,null);});
      if(added===0||cs.length<PS)fin=true;
    })
    .catch(function(){fin=true;})
    .finally(function(){busy=false;if(!fin)next();});
  }
  if(Object.keys(loaded).length>=PS)next();
}
var __fbveBoot=function(){ (window.requestIdleCallback||function(cb){return setTimeout(cb,200);})(boot); };
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",__fbveBoot);else __fbveBoot();
})();